import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingState } from '../../../../../common/global/models';
import Loader from '../../../../../common/widgets/Loader';
import LoadingSpinner from '../../../../../common/widgets/LoadingSpinner';
import { parseProducts } from '../../../helpers';
import { ProductCardModel, ProductListModel } from '../../../models/Product';
import { resources } from '../../../resources/resources';
import { productsService } from '../../../services/products';
import ProductListItem from '../../Common/ProductListItem';

type TopDiscountedProductsState = {
  productList: ProductListModel[];
  productListState: LoadingState;
};
interface TopDiscountedProductsProps {
  categoryId?: number;
}

export default function TopDiscountedProducts(
  props: TopDiscountedProductsProps,
) {
  const { categoryId } = props;
  const { t: translate } = useTranslation();
  const [state, setState] = useState<TopDiscountedProductsState | null>(null);

  useEffect(() => {
    const abortController = new AbortController();
    setState(null);
    (async () => {
      const result = await productsService.getTopDiscountedProducts(
        categoryId,
        undefined,
        {
          signal: abortController?.signal,
        },
      );
      if (!result.hasErrors) {
        setState({
          productList: result.data,
          productListState: LoadingState.Ready,
        });
      }
    })();

    return () => {
      abortController.abort();
    };
  }, [categoryId]);

  return state?.productList && state?.productList?.length > 0 ? (
    <section className="page-section">
      <h2 className="section-title">
        <span>{translate(resources.products.topDiscounted)}</span>
      </h2>

      <Loader loading={!state} loader={<LoadingSpinner />}>
        <div className="card-list card-list-4 card-list-sm-3 card-list-xs-2">
          {!!state &&
            _.map(
              parseProducts(state?.productList.slice(0, 4)),
              (product: ProductCardModel) => {
                return (
                  <ProductListItem key={product.productId} product={product} />
                );
              },
            )}
        </div>
      </Loader>
    </section>
  ) : (
    <></>
  );
}
